import { Auth } from '@core/auth';

import i18n from '@plugins/i18n';

import LibrarySidebar from '@/components/sidebars/LibrarySidebar.vue';

export default [
    {
        path: '/library',
        name: 'LibraryIndex',
        components: {
            default: () => import('@/views/LibraryIndex.vue'),
            sidebar: {
                active: () => !Auth().is_investor,
                render(h) {
                    return h(LibrarySidebar);
                }
            }
        },
        children: [
            {
                path: ':library?',
                name: 'Library',
                component: () => import('@/views/Library.vue'),
                meta: {
                    overline: i18n.t('library'),
                    title: i18n.t('library'),
                    heading: i18n.t('library'),
                    organisations: ['ADVISER', 'INVESTOR', 'FUND_MANAGER', 'PRODUCT_PROVIDER'],
                    retainQuerySelectors: ['investor_id'],
                    sidebarKey: 'library-sidebar'
                }
            }
        ]
    }
];
